export default __webpack_public_path__ + "static/media/logo_trasnbrasil.995e542f.png";